<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 0H16V1.14286L9.84615 6.85714V13.7143L6.15385 16V6.85714L0 1.14286V0Z"
      fill="#77A0D6"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: [Number, String], default: 24 },
    height: { type: [Number, String], default: 18 },
    color: { type: String, default: "#D3D4DE" },
  },
};
</script>
